<template>
    <div class="filter-comp">
        <div class="filter-block filter-title">
            <span>
                <img src="@/assets/img/icon/biz_filter_black.svg" alt="">
                篩選
            </span>
            <span v-show="filterState" class="clear-filter" @click="setFilterDefault">
                清除篩選
            </span>
        </div>
        <div class="filter-block">
            <checkbox :val="true" v-model="filter.canAddGroup" msg="僅顯示可加入群組的房源" :isPropChecked="filter.canAddGroup"></checkbox>
        </div>
        <!-- <div class="filter-block">
            <span v-if="isAllGroup" class="title">業務分群</span>
            <rent-select class="select-scroll" v-if="isAllGroup" refName="orgGroup" style="margin-bottom: 16px;" selectMsg="全部" @getId="getSelectId" border="1px solid #d5dad8" bgColor="#fff" :setDefault="isDefault">
                <ul>
                    <li v-for="(item, index) in groupList" :key="index" :data-id="item.id" :data-name="item.groupName">
                        {{item.groupName}}
                    </li>
                </ul>
            </rent-select>
            <span class="title">業務</span>
            <rent-select class="select-scroll" refName="member" selectMsg="全部" @getId="getSelectId" border="1px solid #d5dad8" bgColor="#fff" :setDefault="isDefault || isGroupChange">
                <ul>
                    <li v-for="(item, index) in memberList" :key="index" :data-id="item.userCid" :data-name="item.name">
                        {{item.name}}
                    </li>
                </ul>
            </rent-select>
        </div>
        <div class="filter-block">
            <span class="title">房東</span>
            <rent-select class="select-scroll" refName="landlord" selectMsg="全部" @getId="getSelectId" border="1px solid #d5dad8" bgColor="#fff" :setDefault="isDefault">
                <ul>
                    <li v-for="(item, index) in landlordList" :key="index" :data-name="item.name">
                        {{item.name}}
                    </li>
                </ul>
            </rent-select>
        </div> -->
    </div>
</template>
<script>
import RentSelect from '@/components/bussiness/widges/tools/RentSelect.vue';
import Checkbox from '@/components/bussiness/widges/input/checkbox.vue';
import { mapGetters } from 'vuex'

export default {
    data () {
        return {
            filter: {
                canAddGroup: true,
                group: '',
                member: '',
                landlord: '',
                noLandlord: ''
            },
            filterState: 0,
            filterIsFixed: false,
            isDefault: false,
            isGroupChange: false,
            componentKey: 0
        }
    },
    mounted () {
        if(!this.isAllGroup){
            this.$store.dispatch('getBizMemberByGroupList', this.groupId)
        }
    },
    watch: {
        filter: {
            handler: function (val) {
                console.log(val)
                this.$store.dispatch('setBizEditHouseGroupFilterQuery', val)
            },
            immediate: true,
            deep: true
        }
    },
    methods: {
        getSelectId: function (value) {
            this.filterState = 1
            this.isDefault = false
            if( value.ref == 'orgGroup' ){
                this.filter.group = value.name
                this.$store.dispatch('getBizMemberByGroupList',(value.id))
                this.isGroupChange = true
                this.filter.member = ''
            }else if( value.ref == 'member' ){
                this.filter.member = value.name
                this.isGroupChange = false
            }else if( value.ref == 'landlord' ){
                this.filter.landlord = value.name
            }
        },
        setFilterWord: function (value) {
            this.filter.word = value
        },
        setFilterDefault: function () {
            let defaultFilter = {
                canAddGroup: true,
                group: '',
                member: '',
                landlord: '',
                noLandlord: ''
            }
            this.filter = defaultFilter
            this.isDefault = true
            setTimeout(()=>{
                this.filterState = 0
                this.isDefault = false
            },100)
        },
    },
    computed: {
        ...mapGetters({
            groupId: 'GET_BIZ_GROUP_ID',
            isAllGroup: 'GET_BIZ_IS_ALL_GROUP',
            groupList: 'GET_ORG_GROUP_LIST',
            memberList: 'GET_ORG_MEMBER_BY_GROUP_LIST',
            landlordList: 'GET_LANDLORD_LIST',
        })
    },
    components: {
        RentSelect,
        Checkbox
    }
}
</script>
<style lang="scss" scoped>
    .filter-comp{
        position: relative;
        width: 270px;
        background: #fff;
        border-radius: 8px;
        border: solid 1px #f0f0f0;
        padding-bottom: 20px;
        margin-bottom: 200px;
        .title{
            display: block;
            font-size: 16px;
            margin-bottom: 16px;
        }
        .filter-block{
            padding: 20px;
            border-bottom:2px solid #f6f6f6 ;
            .biz-rent-select{
                padding: 13px 16px;
                height: 18px;
            }
            &.filter-title{
                span:nth-child(1){
                    display: flex;
                    align-items: center;
                    color: #676362;
                    img{
                        margin-right: 12px;
                    }
                }
                .clear-filter{
                    position: absolute;
                    cursor: pointer;
                    font-size: 12px;
                    color: #ff9275;
                    top: 24px;
                    right: 17px;
                }
            }
            > .table-search{
                input{
                    width: 100%;
                }
            }
            &.location{
                .group{
                    display: flex;
                    .biz-rent-select:nth-child(1){
                        margin-right: 10px;
                    }
                    .biz-rent-select{
                        width: 75px;
                        height: 18px;
                    }
                }
            }
        }
        
        
    }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/mgtCategory/houseGroupMgt/editHouseGroup/editHouseGroupFilter.vue